module.exports = __webpack_public_path__ + "5ffc6b165fc20507fb60920d8227d6e3.png";